// @ts-nocheck
export default function appStore() {
  return {
    get: () => {
      // For Android we can retrieve data directly over the bridge
      // iOS and ReactNative will write the data on the window.seamlyBridgeData object on init
      if (Object.prototype.hasOwnProperty.call(window, 'SeamlyBridge')) {
        try {
          return JSON.parse(window.SeamlyBridge.getData())
        } catch (e) {
          console.error('Unexpected or malformed data retrieved from bridge', e)
          // Android should always return unchanged JSON data.
          // If something went wrong parsing the response, it's best to start from scratch
          return {}
        }
      }
      return window.seamlyBridgeData
    },
    set: (newData) => {
      // iOS
      if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.seamlyBridge
      ) {
        window.webkit.messageHandlers.seamlyBridge.postMessage(
          JSON.stringify(newData),
        )
      }

      // Android
      if (Object.prototype.hasOwnProperty.call(window, 'SeamlyBridge')) {
        window.SeamlyBridge.setData(JSON.stringify(newData))
      }

      // React Native
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify(newData))
      }
    },
  }
}
